import { GetFormattedImages } from '../HotelImages.types';

export const getFormattedImages: GetFormattedImages = images => {
    return images.map(image => ({
        url: image,
        preview_url: image,
    }));
};
